import { render, staticRenderFns } from "./admin-calendar.vue?vue&type=template&id=46058168&scoped=true&"
import script from "./admin-calendar.vue?vue&type=script&lang=js&"
export * from "./admin-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46058168",
  null
  
)

export default component.exports